import React from 'react';

import { SweepText, type SweepTextVariant } from '@/components/ui/sweep-text';

export interface ConversationStatusProps {
  className?: string;
  children?: React.ReactNode;
  variant?: SweepTextVariant;
}

export const ConversationStatus = ({
  className,
  children = 'Working',
  variant = 'yellowfin',
}: ConversationStatusProps) => {
  return (
    <SweepText className={className} variant={variant}>
      {children}
    </SweepText>
  );
};
